import {getConnection} from '../_shared/GWTBridge/invoke/genPage';
import {getStateXml} from '../_shared/GWTBridge/invoke/server';
import {buildServerCall} from './wcfService';

export function deleteMacro(currentForm, macro) {
    const methodName = 'FormMacroDelete';
    const reason = 'Delete macro';

    const statexml = getStateXml(currentForm.session);
    const parameters = {
        statexml: [statexml],
        macro: [macro]
    };

    return buildServerCall(methodName, parameters, reason, false, getConnection, true);
}

export function macroRecord(
    currentForm,
    macro,
    name,
    activate,
    xml,
    processAsDataSet = true,
    processInGwt = false
) {
    const methodName = 'FormMacroRecord';
    const reason = 'Macro Record';

    const statexml = getStateXml(currentForm.session);
    const parameters = {
        statexml: [statexml],
        macro: [macro],
        name: [name],
        activate: [activate.toString()]
    };

    if (xml) {
        parameters['xml'] = [xml];
    }
    return buildServerCall(
        methodName,
        parameters,
        reason,
        processInGwt,
        getConnection,
        processAsDataSet
    );
}

export function macroKey(currentForm, macro, key) {
    const methodName = 'FormMacroKey';
    const reason = 'Macro key';

    const statexml = getStateXml(currentForm.session);
    const parameters = {
        statexml: [statexml],
        macro: [macro],
        key: [key]
    };

    return buildServerCall(methodName, parameters, reason, false, getConnection, true);
}
